// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__MgRsq","modalContent":"style_modalContent__hmj6Z","swiperPagination":"style_swiperPagination__e4swA","fullImage":"style_fullImage__0Ic1z"};